import { imageUploadResponseSchema, type ImageUploadResponse } from '@apuestapr/contracts';

import { interpretApiResponse, type ApiResult } from './client.ts';

export interface ImageUploadOptions {
  readonly baseUrl: string;
  readonly file: File;
  readonly csrfToken: string;
  readonly fetch?: typeof globalThis.fetch;
}

/**
 * The sole multipart request in the dashboard. The browser supplies the boundary; setting
 * Content-Type here would make the body unparsable. Credentials and CSRF are always included.
 */
export const uploadImage = async ({
  baseUrl,
  file,
  csrfToken,
  fetch: fetchImpl = globalThis.fetch,
}: ImageUploadOptions): Promise<ApiResult<ImageUploadResponse>> => {
  const body = new FormData();
  body.append('image', file);

  let response: Response;
  try {
    response = await fetchImpl(`${baseUrl}/api/admin/images`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'x-csrf-token': csrfToken,
      },
      credentials: 'include',
      body,
    });
  } catch (cause) {
    return {
      ok: false,
      failure: {
        kind: 'unreachable',
        message: cause instanceof Error ? cause.message : String(cause),
      },
    };
  }

  return interpretApiResponse(response, imageUploadResponseSchema);
};
